const songs = [
    {
        id: "VCK01",
        thumb: "https://i.scdn.co/image/ab67616d0000485133dcbaf383aad23af9a4b7b5",
        title: "Vibe",
        artist: "Cookiee Kawaii",
        rating: 4
    },
    {
        id: "DB02",
        thumb: "https://i.scdn.co/image/ab67616d000048517e4135635fa0e393b31dc407",
        title: "death bed (feat. beabadoobee)",
        artist: "Powfu",
        rating: 3
    },
    {
        id: "MOTS03",
        thumb: "https://i.scdn.co/image/ab67616d00004851aea0d98794e91056c608e069",
        title: "Moral of the Story",
        artist: "Ashe",
        rating: 5
    },
    {
        id: "MYT04",
        thumb: "https://i.scdn.co/image/9bb7e673f1d5605709f576ccfbdfd765d8b58c6a",
        title: "My Truck",
        artist: "Breland",
        rating: 2
    },
    {
        id: "PPL05",
        thumb: "https://i.scdn.co/image/d506fd8f64a0cf745912bb15fecc80a3c971ca9d",
        title: "Pura Pura Lupa",
        artist: "Mahen",
        rating: 3
    },
    {
        id: "WHP06",
        thumb: "https://i.scdn.co/image/ab67616d0000485105c50cf7a461aa654fe9b15a",
        title: "WHATS POPPIN",
        artist: "Jack Harlow",
        rating: 4
    },
    {
        id: "AP07",
        thumb: "https://i.scdn.co/image/ab67616d00004851626c524e10b50daae74879f9",
        title: "Apollo",
        artist: "Smoove'L",
        rating: 4
    },
    {
        id: "CHEG08",
        thumb: "https://i.scdn.co/image/f4f02683810ea9cd03330b0db8ab6a530444740b",
        title: "Carnaval Chegando",
        artist: "Rennan Da Penha",
        rating: 5
    },
    {
        id: "PSY09",
        thumb: "https://i.scdn.co/image/a9284cea0242cedb2fdf9de7711e8041f1b0f484",
        title: "Psycho!",
        artist: "MASE",
        rating: 3
    },
    {
        id: "ANYS10",
        thumb: "https://i.scdn.co/image/445de0881dd3694a836dcb0d9882f45a4b3bacb1",
        title: "Any Song",
        artist: "Zico",
        rating: 4
    }
];

export default songs;